import type { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { anemicReference } from "@/types/backoffice/dto/common/references";

export enum ECivility {
  MISS = "MISS",
  FEMALE = "FEMALE",
  MALE = "MALE",
  UNKNOWN = "UNKNOWN",
}

export const CIVILITY_MISS_ID = 1;
export const CIVILITY_FEMALE_ID = 2;
export const CIVILITY_MALE_ID = 3;
export const CIVILITY_UNKNOWN_ID = 4;

export function mapCivilityToId(civility?: ECivility | null) {
  if (!civility) {
    return CIVILITY_UNKNOWN_ID;
  }

  const mapping: Record<ECivility, number> = {
    [ECivility.MALE]: CIVILITY_MALE_ID,
    [ECivility.FEMALE]: CIVILITY_FEMALE_ID,
    [ECivility.MISS]: CIVILITY_MISS_ID,
    [ECivility.UNKNOWN]: CIVILITY_UNKNOWN_ID,
  };

  return mapping[civility] ?? CIVILITY_UNKNOWN_ID;
}

export function findCivilityFromId(id?: number | null): ECivility {
  if (id === undefined || id === null) {
    return ECivility.UNKNOWN;
  }

  const mapping: Record<number, ECivility> = {
    [CIVILITY_MISS_ID]: ECivility.MISS,
    [CIVILITY_FEMALE_ID]: ECivility.FEMALE,
    [CIVILITY_MALE_ID]: ECivility.MALE,
    [CIVILITY_UNKNOWN_ID]: ECivility.UNKNOWN,
  };

  return mapping[id] ?? ECivility.UNKNOWN;
}

export const civilityDtoSchema = anemicReference(branded.civilityId);

export type TCivilityDto = z.infer<typeof civilityDtoSchema>;
